module.exports = __webpack_public_path__ + "img/rule-manager-empty.0f3ac1a6.svg";